// Histéresis: encoger el header cambia su altura (y el scroll que reajusta el navegador).
// Con un solo umbral eso crea un bucle encoger/expandir ("tiembla"). La franja entre
// umbrales debe ser mayor que la diferencia de altura del header (~68px en móvil).
class BStickyHeader extends HTMLElement {
  connectedCallback() {
    this.condenseAt = Number(this.dataset.condenseAt || 140);
    this.expandAt = Number(this.dataset.expandAt || 40);
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > this.condenseAt) this.classList.add('is-condensed');
        else if (y < this.expandAt) this.classList.remove('is-condensed');
        this.ticking = false;
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }
}

if (!customElements.get('b-sticky-header')) customElements.define('b-sticky-header', BStickyHeader);
